import withAPIAction from 'helpers/withAPIAction'
import {
  SupplierInvoiceListReq,
  UpdateSupplierInvoiceReq,
  SupplierInvoiceDetailReq,
  PaymentReq,
  PatialDetailReq,
  CountReq,
} from './types'
import {
  getSupplierInvoiceListAction,
  updateSupplierInvoiceAction,
  getSupplierInvoiceDetailAction,
  updatePaymentAction,
  getPatialDetailAction,
  getCountAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'
import { getRequestString } from 'helpers/format'

export const supplierInvoiceListAPI = (data: SupplierInvoiceListReq, token: string, xmid: string) => {
  return withAPIAction<SupplierInvoiceListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierInvoiceList}`,
    data,
    token,
    xmid,
  })(getSupplierInvoiceListAction)
}

export const updateSupplierInvoiceAPI = (data: UpdateSupplierInvoiceReq, token: string, xmid: string) => {
  const endPoint = APIPath.updateSupplierInvoice.replace(':id', data.id.toString())
  return withAPIAction<UpdateSupplierInvoiceReq>({
    method: 'PUT',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(updateSupplierInvoiceAction)
}

export const getSupplierInvoiceDetailAPI = (data: SupplierInvoiceDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getSupplierInvoiceByID.replace(':id', data.id.toString())
  return withAPIAction<SupplierInvoiceDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getSupplierInvoiceDetailAction)
}

export const updateSaleOrderPaymentAPI = (data: PaymentReq, token: string, xmid: string) => {
  return withAPIAction<PaymentReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: APIPath.updateInvoicePayment,
    data,
    token,
    xmid,
  })(updatePaymentAction)
}

export const getPatialDetailAPI = (data: PatialDetailReq, token: string, xmid: string) => {
  const endPoint = APIPath.getPatialPaymentByID.replace(':id', data.id.toString())
  return withAPIAction<PatialDetailReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: endPoint,
    data,
    token,
    xmid,
  })(getPatialDetailAction)
}

export const getCountInvoiceAPI = (data: CountReq, token: string, xmid: any) => {
  return withAPIAction<CountReq>({
    method: 'GET',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.countInvoice}`,
    data,
    token,
    xmid,
  })(getCountAction)
}
